import * as React from "react";
const SvgQrCode = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M26 38H22V34H26V38ZM22 24H18V34H22V24ZM38 20H34V28H38V20ZM34 16H30V20H34V16ZM10 20H6V24H10V20ZM6 16H2V20H6V16ZM20 6H24V2H20V6ZM5 5V11H11V5H5ZM14 14H2V2H14V14ZM5 29V35H11V29H5ZM14 38H2V26H14V38ZM29 5V11H35V5H29ZM38 14H26V2H38V14ZM34 34V28H26V32H30V38H38V34H34ZM30 20H22V24H30V20ZM22 16H10V20H14V24H18V20H22V16ZM24 14V10H20V6H16V14H24ZM9.5 6.5H6.5V9.5H9.5V6.5ZM9.5 30.5H6.5V33.5H9.5V30.5ZM33.5 6.5H30.5V9.5H33.5V6.5Z" }));
export default SvgQrCode;
